import assert from 'assert';
import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {
  getPowAgnosticProcedureFromFlowchartVersion,
  getPowAgnosticTemplateFlowchartVersionFromProcedureRun,
} from 'procedures/utils/powAgnosticFlowchartHelpers';
import {ProcedureRunDetailsViewQuery_procedureRun_ProcedureRunNode as ProcedureRunNode} from 'studies/typed/shared/__generated/ProcedureRunDetailsViewQuery';

import {MetadataTabLayout} from './MetadataTabLayout';
import ProcedureRunDescriptionEditor from './ProcedureRunDescriptionEditor';

interface ProcedureRunMetadataTabProps {
  procedureRun: ProcedureRunNode;
  refetch: () => void;
}

export const ProcedureRunMetadataTab = ({
  procedureRun,
  refetch,
}: ProcedureRunMetadataTabProps): JSX.Element => {
  const flowchartVersion = getPowAgnosticTemplateFlowchartVersionFromProcedureRun(procedureRun);
  assert(!isInaccessible(flowchartVersion), 'Expected flowchart version to be accessible.');
  const procedureParent = getPowAgnosticProcedureFromFlowchartVersion(flowchartVersion);

  return (
    <MetadataTabLayout
      name={procedureRun.name}
      descriptionEditor={
        <ProcedureRunDescriptionEditor
          procedureRunId={procedureRun.id}
          isBeingCreated={false}
          description={procedureRun.description}
          refetch={refetch}
        />
      }
      procedureId={procedureParent.id}
      flowchartVersionId={flowchartVersion.id}
      createdAt={procedureRun.createdAt}
      procedureType={procedureRun.procedureType}
    />
  );
};
